module.exports = __webpack_public_path__ + "static/media/christ-chapel.fb5cf829.svg";